(function() {
	'use strict';

	angular
		.module('pwc.model')
		.service('WineDrink', WineDrink);

	WineDrink.$inject = ['$window', 'BaseModel', 'Transaction', 'lodash'];

	function WineDrink($window, BaseModel, Transaction, lodash) {

		// Entity Defaults
		var defaults = $window.stampit().state({
			"type": "drink",
			"date": new Date(),
			"food": null,
			"location": null,
			"notes": null,
			"qty": 1,
			"with": null,
			"rating": {
				"general": null,
				"point": null // user's numeric rating
			}
		});

		var WineDrinkFactory = $window.stampit().enclose(function () {

			this.getSummary = function(){
				var summary = 'You drank ' + this.qty + ' bottle' + (this.qty > 1 ? 's ' : ' ');

				if (this.with){
					summary +=  'with ' + this.with;
				}

				if (this.location){
					summary += ' at ' + this.location;
				}

				summary = summary.trim() + '. ';

				if (this.food){
					summary += 'You paired it with ' + this.food + '. ';
				}

				if (this.rating.point){
					summary += 'Your 100 pt rating: ' + this.rating.point + '. ';
				}

				if (this.rating.general){
					summary += this.rating.general;
				}

				return summary;
			};

			/**
			 * hasPoints
			 *
			 * checks if points have been stored in this rating
			 * either in the .ratings obj or in the notes (legacy)
			 *
			 * @returns {boolean}
             */
			this.hasPoints = function(){
				var hasPoints = false;

				// each history stored ratings as r
				lodash.forEach(this.rating, function(r) {
					// not null
					if (r) {
						hasPoints = true;
						// break forEach
						return false;
					}
				});

				// only check notes if we need to
				if (hasPoints === false && lodash.isNotEmptyOrNull(this.notes) && this.notes.indexOf('point') > -1) {
					hasPoints = true;
				}

				return hasPoints;
			};

			return $window.stampit.mixIn(this, BaseModel, Transaction);

		});

		return function (properties){
			return $window.stampit.compose(defaults, WineDrinkFactory).create(properties);
		};

	}

})();
